"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountyCodes = void 0;
const enums_1 = require("../enums");
/**
 * return county codes for a given USA state name
 * ```ts
 * example return list of county codes in this format
 * { code: '32', description: 'Lexington'}
 * ```
 * @param state
 * @returns list of counties for the given state name or an empty list if not found
 */
function getCountyCodes(state = enums_1.USStateName.SOUTH_CAROLINA) {
    if (state === enums_1.USStateName.SOUTH_CAROLINA) {
        return JSON.parse(JSON.stringify(southCarolinaCountyCodes));
    }
    else {
        return [];
    }
}
exports.getCountyCodes = getCountyCodes;
/**
 * list of county codes for South Carolina
 */
const southCarolinaCountyCodes = [
    { code: '1', description: 'Abbeville' },
    { code: '2', description: 'Aiken' },
    { code: '3', description: 'Allendale' },
    { code: '4', description: 'Anderson' },
    { code: '5', description: 'Bamberg' },
    { code: '6', description: 'Barnwell' },
    { code: '7', description: 'Beaufort' },
    { code: '8', description: 'Berkeley' },
    { code: '9', description: 'Calhoun' },
    { code: '10', description: 'Charleston' },
    { code: '11', description: 'Cherokee' },
    { code: '12', description: 'Chester' },
    { code: '13', description: 'Chesterfield' },
    { code: '14', description: 'Clarendon' },
    { code: '15', description: 'Colleton' },
    { code: '16', description: 'Darlington' },
    { code: '17', description: 'Dillon' },
    { code: '18', description: 'Dorchester' },
    { code: '19', description: 'Edgefield' },
    { code: '20', description: 'Fairfield' },
    { code: '21', description: 'Florence' },
    { code: '22', description: 'Georgetown' },
    { code: '23', description: 'Greenville' },
    { code: '24', description: 'Greenwood' },
    { code: '25', description: 'Hampton' },
    { code: '26', description: 'Horry' },
    { code: '27', description: 'Jasper' },
    { code: '28', description: 'Kershaw' },
    { code: '29', description: 'Lancaster' },
    { code: '30', description: 'Laurens' },
    { code: '31', description: 'Lee' },
    { code: '32', description: 'Lexington' },
    { code: '34', description: 'Marion' },
    { code: '35', description: 'Marlboro' },
    { code: '33', description: 'McCormick' },
    { code: '36', description: 'Newberry' },
    { code: '37', description: 'Oconee' },
    { code: '38', description: 'Orangeburg' },
    { code: '39', description: 'Pickens' },
    { code: '40', description: 'Richland' },
    { code: '41', description: 'Saluda' },
    { code: '42', description: 'Spartanburg' },
    { code: '43', description: 'Sumter' },
    { code: '44', description: 'Union' },
    { code: '45', description: 'Williamsburg' },
    { code: '46', description: 'York' },
    { code: '99', description: 'County Unknown' }
];
//# sourceMappingURL=county-codes.js.map